import { render, staticRenderFns } from "./ListOfAcceptorsStages.vue?vue&type=template&id=a3035eb0"
import script from "./ListOfAcceptorsStages.vue?vue&type=script&lang=js"
export * from "./ListOfAcceptorsStages.vue?vue&type=script&lang=js"
import style0 from "./ListOfAcceptorsStages.vue?vue&type=style&index=0&id=a3035eb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports